export enum EVENTS {
  SIGNUP_START_STEP_ASK_QUESTIONS = "Signup start step ask questions",
  SIGNUP_COMPLETE_QUESTIONS = "Signup complete questions",
  SIGNUP_COMPLETE_STEP_CHOOSE_PLAN = "Signup complete step choose plan",
  SIGNUP_COMPLETE_STEP_CHOOSE_AMOUNT = "Signup complete step choose amount",
  SIGNUP_COMPLETE_STEP_SIGNUP_FORM = "Signup complete step signup form",
  SIGNUP_COMPLETE_DELIVERY_FORM = "Signup complete delivery form",
  SIGNUP_COMPLETE_CREDIT_CARD_FORM = "Signup complete credit card form",
}
